import Cookies from "js-cookie";
import {
  CookiesConfig,
  CookiesName,
  XCustomHeaderName,
} from "../configs/cookies";

export const isExistsHeaderForToken = (headers) => {
  return headers[XCustomHeaderName.TOKEK];
};

export const isExistsCookies = () => {
  return Cookies.get(XCustomHeaderName.TOKEK) ? true : false;
};

export const setCookies = (response) => {
  const cookiesConfig = CookiesConfig();
  if (isExistsHeaderForToken(response.headers)) {
    Cookies.set(
      CookiesName.TOKEK,
      response.headers[XCustomHeaderName.TOKEK],
      cookiesConfig
    );
  }
};

export const getAccessTokenFromResponseHeader = (response) => {
  return response.headers[XCustomHeaderName.TOKEK];
};

export const getAccessTokenFromCookies = () => {
  return Cookies.get(CookiesName.TOKEK);
};

export const removeCookies = () => {
  Object.keys(Cookies.get()).forEach((cookieName) => {
    const neededAttributes = { path: "/" };
    Cookies.remove(cookieName, neededAttributes);
  });
};
